/*
  Session bundle bar (sections/session-complete.liquid): keeps the "Full Session"
  prices and "Add all" in step with the product page above it. The page's
  product goes in with the variant picked there (data-product-variant-id on the
  product element, set by the theme) and the quantity in its stepper; the
  companions' total comes from the section. The struck-through total, the price
  after the discount (floored to the cent like Shopify does) and the saving are
  redrawn, and so is the "This item" tile (photo, price · variant).
*/
if (!customElements.get('session-complete-bundle')) {
  class SessionCompleteBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      try {
        this.variants = JSON.parse(this.querySelector('[data-session-bundle-json]').textContent);
      } catch (error) {
        return;
      }
      this.section = this.closest('.session-complete');
      this.product = document.querySelector('.session-pdp[data-js-product]');
      this.quantityInput = this.product && this.product.querySelector('.session-pdp__qty-input');
      if (!this.product) return;

      new MutationObserver(() => this.update()).observe(this.product, {
        attributes: true,
        attributeFilter: ['data-product-variant-id'],
      });
      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', () => this.update());
        this.quantityInput.addEventListener('change', () => this.update());
      }
      this.update();
    }

    money(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    update() {
      const id = this.product.getAttribute('data-product-variant-id');
      const variant = this.variants[id];
      if (!variant) return;
      const quantity = Math.min(99, Math.max(1, parseInt(this.quantityInput && this.quantityInput.value, 10) || 1));
      const percent = Number(this.dataset.percent) || 0;
      const total = variant.price * quantity + (Number(this.dataset.companions) || 0);
      const saving = Math.floor((total * percent) / 100);

      const set = (selector, text) => {
        const el = this.querySelector(selector);
        if (el) el.textContent = text;
      };
      set('[data-session-bundle-was]', this.money(total));
      set('[data-session-bundle-now]', this.money(total - saving));
      set('[data-session-bundle-save]', this.money(saving));

      this.querySelector('[data-session-bundle-id]').value = id;
      this.querySelector('[data-session-bundle-quantity]').value = quantity;
      const button = this.querySelector('[data-session-submit]');
      if (button) {
        button.toggleAttribute('data-unavailable', !variant.available);
        if (!button.hasAttribute('data-busy')) button.disabled = !variant.available;
      }

      // The "This item" tile follows the variant.
      const tile = this.section && this.section.querySelector('.session-complete__card--this');
      if (!tile) return;
      const meta = tile.querySelector('[data-session-bundle-meta]');
      if (meta) meta.textContent = this.money(variant.price) + (variant.label ? ' · ' + variant.label : '');
      // The photo the page opened with is already right; swap only on a change.
      if (this.shownId === undefined) this.shownId = id;
      const image = tile.querySelector('.session-complete__image');
      if (image && variant.image && this.shownId !== id) {
        image.removeAttribute('srcset');
        image.src = variant.image;
      }
      this.shownId = id;
    }
  }

  customElements.define('session-complete-bundle', SessionCompleteBundle);
}
